export const config = {
    live: 'https://api.bigadvice.com/',
    development: `http://testapi.bigadvice.com/`
}




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_models/apiConfig.ts